import { evaluateFormula } from './evaluate-formula';

const VARIABLE_REGEX = /{{(.*?)}}/g;

export function evaluateFormulaRecursive(
  formula: string,
  formulas: Record<string, string>,
  scope: Record<string, string | string[] | number | undefined>,
  visited: Set<string> = new Set(),
  memo: Map<string, string> = new Map()
): string {
  if (memo.has(formula)) {
    return memo.get(formula)!;
  }

  const resolvedScope: Record<string, unknown> = { ...scope };

  const variables = Array.from(formula.matchAll(VARIABLE_REGEX)).map(
    (match) => match[1]
  );

  for (const variable of variables) {
    if (resolvedScope[variable] === undefined) {
      if (visited.has(variable)) {
        throw new Error(
          `Circular dependency detected on variable: ${variable}`
        );
      }

      visited.add(variable);

      const subFormula = formulas[variable] ?? '0';

      const subResult = evaluateFormulaRecursive(
        subFormula,
        formulas,
        scope,
        visited,
        memo
      );

      visited.delete(variable);

      resolvedScope[variable] = subResult;
      memo.set(subFormula, subResult);
    }
  }

  const result = evaluateFormula(formula, resolvedScope);

  memo.set(formula, result);

  return result;
}
